import { Navigate, createFileRoute } from "@tanstack/react-router";

import { resolveCurrentPublicDiscoverySlug } from "@/lib/customer-resolution";

export const Route = createFileRoute("/discovery/")({
  component: DiscoveryCompatibility,
});

function DiscoveryCompatibility() {
  return (
    <Navigate
      to="/discovery/$publicCustomerSlug"
      params={{ publicCustomerSlug: resolveCurrentPublicDiscoverySlug() }}
      replace
    />
  );
}
